import React from 'react';
import styles from './DropDownItem.scss';
import classNames from 'classnames';

export interface DropdownItemProps {
  onClick: () => void;
  label: string | JSX.Element;
}

export const DropdownItem: React.FC<DropdownItemProps> = (props) => {
  const onClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    props.onClick();
    const customEvent = new CustomEvent('dropdown-item-clicked', { bubbles: true });
    e.currentTarget.dispatchEvent(customEvent);
  };

  return (
    <button className={classNames('dropdown-item', styles['au-dropdownitem'])} onClick={onClick}>
      {props.label}
    </button>
  );
};
